// Angular
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Afidium
import { Yii } from "libraries/interfaces/Yii";
import { AppRootService } from 'app/shared/services/app-root/app-root-service';
import { ViewsService } from 'libraries/view/views.service';
import { WORDING } from './config/wording';
import { IBreadcrumbItem } from 'libraries/service/breadcrumb/IBreadcrumbItem';
import { SmsBreadcrumbService } from './services/sms-breadcrumb.service';
import { ProcessingSmsService } from './services/processing-sms.service';
import { SashaPageComponent } from '../sasha-page.component';
import { ITemplate, ITemplateListLabels } from 'app_sasha/shared/interfaces/ITemplateList';
import { ISmsTemplate } from 'app_sasha/shared/interfaces/ISms';
import { ProcessingSmsResourceService } from 'app_sasha/shared/resources/processing-sms-resource/processing-sms-resource.service';
import { ILabels } from 'libraries/interfaces/ILabels';
import { ResourceError } from 'libraries/service/resource/ResourceError';
import { TitleService } from 'app_sasha/shared/services/title/title.service';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";

@Component({
    selector: 'processing-sms',
    template: `
        <div class="app-wrapper app-sasha">
            <breadcrumb [items]="breadcrumbItems"></breadcrumb>
            <template-list
                [templates]="smsTemplates"
                [labels]="templateListLabels"
                (onSelectTemplate)="selectTemplate($event)"
                (onGoToFormView)="goToFormView()"
            ></template-list>
        </div>
    `
})
export class ProcessingSmsComponent extends SashaPageComponent implements OnInit {
    public wording: ILabels = WORDING;
    public breadcrumbItems: IBreadcrumbItem[] = [];
    public smsTemplates: ITemplate[] = [];

    public smsTemplateLoader: {
        active: boolean,
        message: string
    } = {
            active: false,
            message: null
        };

    public notification: {
        active: boolean;
        message: string;
        type: 'error' | 'success' | 'info'
    } = {
            active: false,
            message: null,
            type: 'error'
        };

    public templateListLabels: ITemplateListLabels = {
        writeMessageWithoutTemplate: Yii.t('wui-sasha-js', 'Ecrire un SMS sans modèle'),
        modelsListCardHeader: Yii.t('wui-sasha-js', 'Liste des modèles de SMS')
    };

    constructor(
        protected viewsService: ViewsService,
        appRootService: AppRootService,
        private readonly router: Router,
        private readonly processingSmsService: ProcessingSmsService,
        private readonly smsBreadcrumbService: SmsBreadcrumbService,
        private readonly processingSmsResourceService: ProcessingSmsResourceService,
        private readonly titleService: TitleService,
        private readonly errorTracingService: ErrorTracingService,
    ) {
        super(viewsService, appRootService);
    }

    public ngOnInit(): void {
        // Initialize breadcrumb
        this.breadcrumbItems = this.smsBreadcrumbService.breadcrumbList();

        this.titleService.setTitle(Yii.t("wui-sasha-js", "Choix du modèle de SMS"));

        // Get sms model list
        this.processingSmsResourceService.getSmsTemplates()
            .subscribe(
                (smsTemplates: ITemplate[]) => this.smsTemplates = smsTemplates,
                (error: ResourceError) => this.notification = {
                    active: true,
                    type: 'error',
                    message: this.wording.getSmsTemplatesError + error.message
                }
            );
    }

    public selectTemplate(selectedTemplate: ITemplate): void {
        this.processingSmsResourceService.getSmsTemplate(selectedTemplate.id)
            .subscribe(
                (emailTemplate: ISmsTemplate) => this.processingSmsService.form = emailTemplate,
                (error: Error) => this.notification = {
                    active: true,
                    type: 'error',
                    message: this.wording.getOneSmsTemplate + error.message
                },
                () => {
                    this.smsTemplateLoader.active = false;
                    this.router.navigate(['/sasha/processing-sms/form'], {
    queryParamsHandling: 'preserve'
}).catch((reason: boolean) => { this.errorTracingService.captureException(reason); });
                }
            );
    }

    public goToFormView(): void {
        this.processingSmsService.form = null;
        this.router.navigate(['/sasha/processing-sms/form'], {
    queryParamsHandling: 'preserve'
}).catch((reason: boolean) => { this.errorTracingService.captureException(reason); });
    }
}
